// extracted by mini-css-extract-plugin
module.exports = {"OnBoardingFlowItem":"OnboardingFlowItem_OnBoardingFlowItem__3fHbT"};